import useTableCols from './useTableCols/useTableCols';
import useTableRows from './useTableRows/useTableRows';

const useTableLayout = ({
  teams,
  selectedGroup,
  contributorsById,
  metrics,
  tableMetricsNames,
  availableMetricsWidgets,
  metricsPerGranularity = [],
  aggregatedLastPeriodMetrics,
  metricsPerGranularityLastPeriod = [],
  lastPeriodDates
}) => {
  const cols = useTableCols({
    selectedGroup,
    tableMetricsNames,
    availableMetricsWidgets
  });
  const rows = useTableRows({
    teams,
    contributorsById,
    metrics,
    tableMetricsNames,
    availableMetricsWidgets,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    lastPeriodDates
  });

  return {
    cols,
    rows
  };
};

export default useTableLayout;
